"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeLogItem = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const ValueChange_1 = require("../domain/ValueChange");
const transformToDate_1 = require("../transformers/transformToDate");
class ChangeItem {
    key;
    previousValue;
    currentValue;
    get changeType() {
        return (0, ValueChange_1.determineChangeType)(this.previousValue, this.currentValue);
    }
}
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ChangeItem.prototype, "key", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ChangeItem.prototype, "previousValue", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ChangeItem.prototype, "currentValue", void 0);
class ChangeLogItem {
    changedByUserId;
    cid;
    changedAt;
    changes = [];
    metadata = {};
}
exports.ChangeLogItem = ChangeLogItem;
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ChangeLogItem.prototype, "changedByUserId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ChangeLogItem.prototype, "cid", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], ChangeLogItem.prototype, "changedAt", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], ChangeLogItem.prototype, "changes", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ChangeLogItem.prototype, "metadata", void 0);
//# sourceMappingURL=ChangeLogItem.js.map